import { memo, useEffect } from 'react';

import { useSelector } from 'react-redux';

import { sendClick } from 'reaxl-analytics';

import vdpResultsDuck from '@/ducks/vdp/vdpResultsDuck.js';

/**
 * Adds a listener to print event using the window beforeprint event, and defaults to matchMedia
 * print detection if the window's beforeprint isn't available. Returns a function to remove the listener
 * @param   {Function} onPrint - Callback called when print event detected
 * @returns {Function} Removes event listener when called
 */

const handlePrintEventListener = (onPrint) => {
    if ('onbeforeprint' in window) {
        window.addEventListener('beforeprint', onPrint);

        return () => {
            window.removeEventListener('beforeprint', onPrint);
        };
    }

    const mediaQueryEvent = window.matchMedia('print');

    /**
     * Checks if mediaQueryList object detects print event
     * @param event {Event} - Event Listener when print is fired
     */
    const isPrintEvent = (event) => {
        if (mediaQueryEvent.matches) {
            onPrint(event);
        }
    };

    mediaQueryEvent.addListener(isPrintEvent);

    return () => {
        mediaQueryEvent.removeListener(isPrintEvent);
    };
};

function TrackPrintComponent() {
    const listing = useSelector(vdpResultsDuck.selectors.getVdpActiveInventory);

    useEffect(() => {
        if (Object.keys(listing).length) {
            const removePrintEventListener = handlePrintEventListener((event) => {
                sendClick('printTrack', event);
            });

            return () => {
                removePrintEventListener();
            };
        }

        return () => { };
    }, [listing]);

    return null;
}

export default memo(TrackPrintComponent);
